import type { IconData } from '@stacksjs/iconify-core'

export const bd4x3: IconData = {
  "body": "<path fill=\"#006a4e\" d=\"M0 0h640v480H0z\"/><circle cx=\"280\" cy=\"240\" r=\"160\" fill=\"#f42a41\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default bd4x3
